import React from 'react';
import { MemoryRouter, BrowserRouter, Route } from 'react-router-dom';

import Home from './containers/home/index';
import HomeGoogle from './containers/home/google';
import Details from './containers/details/index';
import DetailsGoogle from './containers/details/google';
import AutonomousDetail from './containers/autonomous_detail/index';
import MunicipalDetail from './containers/municipalDetail/index';
import EuropeDetail from './containers/europeDetail/index';
import Pactometro from './containers/pactometro/index';
import Plaza from './containers/plaza/index';
import BarsContainer from './containers/barsContainer';
import TableRankingContainer from './containers/tableRankingContainer';
import RankingPactometro from './containers/rankingPactometro';
import MiniPactometro from './containers/miniPactometro';
import Ticker from './containers/autonomicTicker';
import ChartCompare from './containers/chartCompare/index';
import Compare from './containers/comparativa/index';
import ChartCompareSenate from './containers/chartCompareSenate/index';
import TickerContainer from './containers/tickerContainer';
import MultiPactometro from './containers/multiPactometro';
import MultiPactometroA3 from './containers/multiPactometroA3';
import TrendGraphContainer from './containers/trendGraphContainer';
import SimpleMunicipalResult from './containers/municipal';
import SimpleAutonomicResult from './containers/province';
import SimpleEuropeanResult from './containers/europeanResults';
import HorizontalGraphContainer from './containers/horizontalGraphContainer';
import ModuleGenerator from './containers/moduleGenerator';
import ButtonGenerator from './containers/moduleGenerator/buttonGenerator';

const Router =
  window.parent !== window ||
  window.location.hostname === 'localhost' ||
  window.location.href.indexOf('tvmodules') !== -1 ||
  window.location.href.indexOf('generador') !== -1
    ? BrowserRouter
    : MemoryRouter;
const Main = ({ entry }) => (
  <div className="_main elecciones-2019">
    <Router basename="/elecciones-2019-2/" initialEntries={[entry]}>
      <div>
        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/resultados-google.html"
          component={HomeGoogle}
        />
        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community?/:province?/resultados.html"
          component={Home}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:province/:town/detalle.html"
          component={Details}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/resultadosmunicipales.html"
          component={SimpleMunicipalResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:town/resultadosmunicipales.html"
          component={SimpleMunicipalResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/resultadosautonomicos.html"
          component={SimpleAutonomicResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:community/resultadosautonomicos.html"
          component={SimpleAutonomicResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:community/:province/resultadosautonomicos.html"
          component={SimpleAutonomicResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/resultadosEuropeas.html"
          component={SimpleEuropeanResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:community/resultadosEuropeas.html"
          component={SimpleEuropeanResult}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:community/:province/resultadosEuropeas.html"
          component={SimpleEuropeanResult}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:province/:town/detalle-google.html"
          component={DetailsGoogle}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:town/detalleMunicipal.html"
          component={MunicipalDetail}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:communityId/:province/:town/detalleAutonomica.html"
          component={AutonomousDetail}
        />

        <Route
          exact
          path="/:masterbar/:reload/:year/:electionNumber/:town/detalleEuropeas.html"
          component={EuropeDetail}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/bars.html"
          component={BarsContainer}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/tableRankingContainer.html"
          component={TableRankingContainer}
        />

        <Route exact path="/plaza.html" component={Plaza} />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/pactometro.html"
          component={Pactometro}
        />
        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/rankingpactometro.html"
          component={RankingPactometro}
        />
        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/minipactometro.html"
          component={MiniPactometro}
        />
        <Route
          exact
          path="/:reload/:year/:type/:electionNumber/:place/multipactometro.html"
          component={MultiPactometro}
        />

        <Route
          exact
          path="/:reload/:year/:type/:electionNumber/:place/multipactometroA3.html"
          component={MultiPactometroA3}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/graficas.html"
          component={ChartCompare}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/graficas.html"
          component={ChartCompare}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/:province/graficas.html"
          component={ChartCompare}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/compare.html"
          component={Compare}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/senate.html"
          component={ChartCompareSenate}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/senate.html"
          component={ChartCompareSenate}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/:community/:province/senate.html"
          component={ChartCompareSenate}
        />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/ticker.html"
          component={TickerContainer}
        />
        <Route exact path="/ticker.html" component={Ticker} />

        <Route
          exact
          path="/:placesIds/:reload/:year/:type/:electionNumber/trendgraph.html"
          component={TrendGraphContainer}
        />

        <Route
          exact
          path="/:year/:electionNumber/:town/horizontalgraph.html"
          component={HorizontalGraphContainer}
        />
        <Route exact path="/test.html" component={ButtonGenerator} />

        <Route exact path="/generador.html" component={ModuleGenerator} />
      </div>
    </Router>
  </div>
);

export default Main;
